import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import VisorArchivo from "@/components/VisorArchivo";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Placeholder from "@/pages/Placeholder";
import AltaClientes from "@/pages/AltaClientes";
import ListaClientes from "@/pages/ListaClientes";
import EstadoCuenta from "@/pages/EstadoCuenta";
import Cotizador from "@/pages/Cotizador";
import Cotizaciones from "@/pages/Cotizaciones";
import Pedidos from "@/pages/Pedidos";
import HistorialPedidos from "@/pages/HistorialPedidos";
import Cobranza from "@/pages/Cobranza";
import PedidosSurtir from "@/pages/PedidosSurtir";
import Inventario from "@/pages/Inventario";
import Comisiones from "@/pages/Comisiones";
import Configuracion from "@/pages/Configuracion";
import UsuariosPermisos from "@/pages/UsuariosPermisos";
import BitacoraAccesos from "@/pages/BitacoraAccesos";
import GuiaInstalacion from "@/pages/GuiaInstalacion";
import SolicitudAltaCliente from "@/pages/SolicitudAltaCliente";
import SolicitudesCliente from "@/pages/SolicitudesCliente";
import CatalogoTerritorial from "@/pages/CatalogoTerritorial";
import ConfiguracionProductos from "@/pages/ConfiguracionProductos";
import ConfiguracionListasPrecios from "@/pages/ConfiguracionListasPrecios";
import ConfiguracionDescuentos from "@/pages/ConfiguracionDescuentos";
import ConfiguracionComisiones from "@/pages/ConfiguracionComisiones";
import FichasTecnicas from "@/pages/FichasTecnicas";
import Data from "@/pages/Data";
import Avisos from "@/pages/Avisos";
import Viajes from "@/pages/Viajes";
import Flotilla from "@/pages/Flotilla";
import MisViajes from "@/pages/MisViajes";
import MiHistorial from "@/pages/MiHistorial";
import ChoferGuard from "@/components/ChoferGuard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/lista-clientes/:id/estado-cuenta"
            element={
              <ProtectedRoute>
                <EstadoCuenta />
              </ProtectedRoute>
            }
          />

          <Route
            element={
              <ProtectedRoute>
                <ChoferGuard><Layout /></ChoferGuard>
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/viajes" element={<Viajes />} />
            <Route path="/flotilla" element={<Flotilla />} />
            <Route path="/mis-viajes" element={<MisViajes />} />
            <Route path="/mi-historial" element={<MiHistorial />} />
            <Route path="/alta-clientes" element={<AltaClientes />} />
            <Route path="/lista-clientes" element={<ListaClientes />} />
            <Route path="/cotizador" element={<Cotizador />} />
            <Route path="/cotizaciones" element={<Cotizaciones />} />
            <Route path="/pedidos" element={<Pedidos />} />
            <Route path="/historial-pedidos" element={<HistorialPedidos />} />
            <Route path="/cobranza" element={<Cobranza />} />
            <Route path="/comisiones" element={<Comisiones />} />
            <Route path="/avisos" element={<Avisos />} />
            <Route path="/inventario" element={<Inventario />} />
            <Route path="/pedidos-surtir" element={<PedidosSurtir />} />
            <Route path="/data" element={<Data />} />
            <Route path="/configuracion" element={<Configuracion />} />
            <Route path="/configuracion/usuarios" element={<UsuariosPermisos />} />
            <Route path="/configuracion/accesos" element={<BitacoraAccesos />} />
            <Route path="/configuracion/guia-instalacion" element={<GuiaInstalacion />} />
            <Route path="/solicitud-alta-cliente" element={<SolicitudAltaCliente />} />
            <Route path="/solicitudes-clientes" element={<SolicitudesCliente />} />
            <Route path="/configuracion/territorial" element={<CatalogoTerritorial />} />
            <Route path="/configuracion/productos" element={<ConfiguracionProductos />} />
            <Route path="/configuracion/listas-precios" element={<ConfiguracionListasPrecios />} />
            <Route path="/configuracion/descuentos" element={<ConfiguracionDescuentos />} />
            <Route path="/configuracion/comisiones" element={<ConfiguracionComisiones />} />
            <Route path="/configuracion/fichas-tecnicas" element={<FichasTecnicas />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <VisorArchivo />
    </AuthProvider>
  );
}

export default App;
